export function LoginInfo() {
  return (
    <div className="space-y-4 text-center">
      <div className="space-y-1 flex flex-col items-center">
        <h2 className="text-2xl font-bold text-white tracking-tight">
          Sistema de Geração de Documentos
        </h2>
        <div className="h-1 w-20 bg-primary rounded-full" />
      </div>
      
      <p className="text-white/90 text-lg leading-relaxed">
        Plataforma integrada para a geração automatizada de ofícios, 
        requerimentos e discursos, otimizando o processo legislativo.
      </p>
    </div>
  )
}